import axios from "axios"
import qs from "qs"
import { getUserIdFromJWT } from "../utils/getUserIdFromJWT"
import { getToken } from "./TokenServce"

const API_URL = process.env.NEXT_PUBLIC_API_URL
const CMS_URL = process.env.NEXT_PUBLIC_CMS_URL

export const CMSAPIService = axios.create({
  baseURL: CMS_URL,
  headers: {
    "Content-Type": "application/json",
  },
})

CMSAPIService.interceptors.request.use(
  async config => {
    config.baseURL = CMS_URL
    return config
  },
  error => {
    console.log(error.data)
    // eslint-disable-next-line no-undef
    Promise.reject(error)
  },
)

CMSAPIService.interceptors.response.use(
  async response => {
    return {
      items: response.data,
      totalPages: response.headers["x-wp-totalpages"],
    }
  },
  async error => {
    // eslint-disable-next-line no-undef
    return Promise.reject(error)
  },
)

export const APIService = axios.create({
  baseURL: API_URL,
  headers: {
    "Content-Type": "application/json",
  },
  paramsSerializer: params => {
    return qs.stringify(params, {
      arrayFormat: "brackets",
    })
  },
})

APIService.interceptors.request.use(
  async config => {
    config.baseURL = API_URL
    config.baseURL = API_URL

    return config
  },
  error => {
    console.log(error.data)
    // eslint-disable-next-line no-undef
    Promise.reject(error)
  },
)

APIService.interceptors.response.use(
  async response => {
    return response.data
  },
  async error => {
    // eslint-disable-next-line no-undef
    return Promise.reject(error)
  },
)

export const APIAuthService = axios.create({
  baseURL: API_URL,
  headers: {
    "Content-Type": "application/json",
  },
  paramsSerializer: params => {
    return qs.stringify(params, {
      arrayFormat: "brackets",
    })
  },
})

APIAuthService.interceptors.request.use(
  async config => {
    config.baseURL = API_URL
    const token = getToken()
    config.baseURL = API_URL

    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }

    if (config.url.includes(":userId") && token) {
      const id = getUserIdFromJWT(token)
      config.url = config.url.replace(":userId", id)
    }

    return config
  },
  error => {
    console.log(error.data)
    // eslint-disable-next-line no-undef
    Promise.reject(error)
  },
)

APIAuthService.interceptors.response.use(
  async response => {
    return response.data
  },
  async error => {
    // eslint-disable-next-line no-undef
    return Promise.reject(error)
  },
)
